import { buyWithTon } from "../utils/purchaseHelpers";
import React, {
  useEffect,
  useRef,
  useState,
  Suspense,
  useCallback,
  useMemo,
} from "react";
import WebApp from "@twa-dev/sdk";
import { safeOpenTelegramLink } from "../utils/linkHelpers";
import axios from "axios";
import { useTonConnectUI } from "@tonconnect/ui-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdSense from "react-adsense";
import Header from "../components/Header";
import { API_URL } from "../config";
import { TonAdInit } from "ton-ai-sdk";
import { useUser } from "../context/UserContext";
import haptic from "../utils/haptic";
import { getDisplayName } from "../utils/getDisplayName";
// import TonAIAd from "../components/TonAIAd";
import Loading from "../components/Loading";
import { FaGem, FaLink, FaPlayCircle, FaTicketAlt } from "react-icons/fa";
// import Banner, { Banner3 } from "../components/AdBanner";
import TaskCard from "../components/TaskCard";
// Corrected lazy import syntax
import { motion, AnimatePresence } from "framer-motion";
import confetti from "canvas-confetti";
import { useTitle } from "../hooks/useTitle";
import ReactGA from "react-ga4";
// Corrected lazy import syntax
import Tabs from "../components/Tabs";
import { ShowAdButton } from "../components/MoneTag";
import { showAd } from "../components/MonetagHelper";

import { FaCalendar, FaListAlt, FaHistory } from "react-icons/fa";
import taskSteps from "../data/taskSteps";
import CustomTooltip from "../components/CustomTooltips";
import TaskSkeleton from "../components/TaskSkeleton";
import EmptyState from "../components/EmptyState";
import useOnboarding from "../hooks/useOnBoarding";
const Joyride = React.lazy(() =>
  import("react-joyride").then((mod) => ({ default: mod.default || mod }))
);
const FormModal = React.lazy(() => import("../components/FormModal"));

// Module-level cache — persists across tab switches within the same session
const CACHE_TTL = 2 * 60 * 1000; // 2 minutes
const tasksCache = { data: null, userId: null, timestamp: 0 };

// Helper to extract @username from Telegram URL
function extractUsernameFromUrl(url) {
  const regex = /https?:\/\/t\.me\/([a-zA-Z0-9_]+)/;
  const match = url.match(regex);
  return match ? `@${match[1]}` : null;
}

const Tasks = () => {
  useTitle("Tasks - Earn Gems and Tickets");
  const { userData, setUserData, refreshUser, APIKey } = useUser();
  const [tonConnectUI] = useTonConnectUI();
  const [tasks, setTasks] = useState([]);
  const [userId, setUserId] = useState(null);
  const [taskVerify, setTaskVerify] = useState({
    taskId: "",
    bscode: "",
  });

  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("active");
  const [isModalOpen, setModalOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const { run, handleCallback, restart } = useOnboarding("hasSeenTaskTour");

  useEffect(() => {
    TonAdInit({
      appId: process.env.REACT_APP_APP_ID,
      debug: false,
    });
  }, []);

  useEffect(() => {
    const initTelegram = async () => {
      const webAppData = WebApp.initDataUnsafe;
      if (webAppData?.user?.id) {
        setUserId(webAppData.user.id);
        setUserData((prev) => ({
          ...prev,
          username: webAppData.user.username,
        }));
        setLoading(true);
        try {
          // Return cached data if still fresh for this user
          const now = Date.now();
          if (
            tasksCache.data &&
            tasksCache.userId === webAppData.user.id &&
            now - tasksCache.timestamp < CACHE_TTL
          ) {
            setTasks(tasksCache.data);
            setLoading(false);
            return;
          }

          const res = await axios.get(`${API_URL}/api/tasks/active`, {
            params: { initData: WebApp.initData },
            headers: {
              "x-api-key": APIKey,
            },
          });
          const allTasks = res.data;

          const userTasksRes = await axios.get(
            `${API_URL}/api/user/${webAppData.user.id}/tasks`,
            {
              params: { initData: WebApp.initData },
              headers: {
                "x-api-key": APIKey,
              },
            }
          );
          const userTasks = userTasksRes.data;

          const userTaskMap = {};
          userTasks.tasks.forEach((userTask) => {
            if (userTask.status !== "disable") {
              userTaskMap[userTask.taskId] = userTask.status;
            }
          });

          const sortedTasks = allTasks.sort((a, b) => {
            if (a.isFeatured && !b.isFeatured) return -1;
            if (!a.isFeatured && b.isFeatured) return 1;
            if (a.isTimeLimited && !b.isTimeLimited) return -1;
            if (!a.isTimeLimited && b.isTimeLimited) return 1;
            return new Date(a.expiresAt) - new Date(b.expiresAt);
          });
          const updatedTasks = sortedTasks.map((task) => {
            const status = userTaskMap[task._id];
            const lastSubmission = new Date(userTasks.lastSubmission);
            const isDailyTask =
              task.isDaily &&
              new Date().getTime() - lastSubmission.getTime() <
              24 * 60 * 60 * 1000;
            return {
              ...task,
              status: isDailyTask
                ? "new"
                : status === "completed"
                  ? "completed"
                  : status === "pending"
                    ? "pending"
                    : status === "verified"
                      ? "verified"
                      : status === "unverified"
                        ? "unverified"
                        : status === "boosted"
                          ? "completed"
                          : status === "code"
                            ? "code"
                            : status === "coded"
                              ? "coded"
                              : status === "reset"
                                ? "reset"
                                : status === "banned"
                                  ? "banned"
                                  : status === "pending_ton"
                                    ? "pending_ton"
                                    : "new",
              hasCompleted: status === "completed",
            };
          });

          setTasks(updatedTasks);
          // Store in cache
          tasksCache.data = updatedTasks;
          tasksCache.userId = webAppData.user.id;
          tasksCache.timestamp = Date.now();
        } catch (error) {
          console.error("Error fetching tasks:", error);
        }
      } else {
        toast.error("No user data found.");
      }
      setLoading(false);
    };

    initTelegram();
  }, []);

  // Ensure tasksCache stays updated whenever local tasks state changes (e.g. after claim)
  useEffect(() => {
    if (tasks.length > 0) {
      tasksCache.data = tasks;
    }
  }, [tasks]);

  const handleVerify = useCallback(async (task) => {
    // GA event for task verification
    ReactGA.event({
      category: "Task",
      action: "Verify",
      label: task.name,
    });

    setButtonLoading(true);
    try {
      const response = await axios.post(
        `${API_URL}/api/tasks/verify`,
        {
          userId: userId,
          taskId: task._id,
          initData: WebApp.initData,
        },
        {
          headers: {
            "x-api-key": APIKey,
          },
        }
      );

      if (response.data.verified) {
        setUserData((prev) => ({
          ...prev,
          user: {
            ...prev.user,
            points: response.data.points,
            tickets: response.data.tickets,
          },
        }));

        toast.success(`You earned ${response.data.earnedPoints} points.`, {
          autoClose: 2000,
          closeButton: false,
          position: "bottom-center",
          pauseOnFocusLoss: false,
        });
        haptic.success();

        setTasks((prevTasks) =>
          prevTasks.map((t) =>
            t._id === task._id ? { ...t, status: "completed" } : t
          )
        );

        // Trigger confetti effect
        confetti({
          particleCount: 100,
          spread: 70,
          origin: { y: 0.6 },
        });
      }
    } catch (error) {
      console.error("Verification error:", error);

      if (error.response?.status === 403) {
        toast.error("Join the channel to earn points.", {
          autoClose: 2000,
          position: "bottom-center",
          pauseOnFocusLoss: false,
        });
        setTasks((prevTasks) =>
          prevTasks.map((t) =>
            t._id === task._id ? { ...t, status: "unverified" } : t
          )
        );
      } else {
        toast.error("Error verifying. Try again later.", {
          autoClose: 2000,
          position: "bottom-center",
          pauseOnFocusLoss: false,
        });
      }
    } finally {
      setButtonLoading(false);
    }
  });

  const handleJoin = useCallback((task) => {
    // GA event for task join
    ReactGA.event({
      category: "Task",
      action: "Join",
      label: task.name,
    });

    setButtonLoading(true);
    safeOpenTelegramLink(task.URL);
    setTasks((prevTasks) =>
      prevTasks.map((t) => (t._id === task._id ? { ...t, hasJoined: true } : t))
    );
    setButtonLoading(false);
  });

  const handleExternal = useCallback(async (task, userStatus) => {
    // GA event for external task
    ReactGA.event({
      category: "Task",
      action: "External",
      label: task.name,
    });

    // Open link immediately for better UX
    if (task.URL && (task.URL.includes("t.me") || task.URL.includes("telegram.me"))) {
      safeOpenTelegramLink(task.URL);
    } else {
      WebApp.openLink(task.URL, "_blank");
    }
    setButtonLoading(true);

    try {
      const url = `${API_URL}/api/user/${userId}/tasks`;
      const statusToSet = "verified";

      if (userStatus === "new") {
        await axios.post(
          url,
          {
            taskId: task._id,
            status: "verified",
            initData: WebApp.initData,
          },
          {
            headers: {
              "x-api-key": APIKey,
            },
          }
        );
      }

      // Update UI immediately to 'pending'
      setTasks((prevTasks) =>
        prevTasks.map((t) =>
          t._id === task._id ? { ...t, status: statusToSet } : t
        )
      );
      await new Promise((resolve) => setTimeout(resolve, 5000));
      setButtonLoading(false);
      // Show success message
      toast.info(`Task verified.`, {
        position: "bottom-center",
      });
    } catch (error) {
      console.error("Error recording link click:", error);
      toast.error("Could not start task. Please try again.");
    } finally {
      setButtonLoading(false);
    }
  });

  const onMessageSent = useCallback(
    async (task, userStatus) => {
      try {
        setMsg("Message sent successfully!");

        const url = `${API_URL}/api/user/${userId}/tasks`;

        const payload = {
          status: "verified",
          lastSubmission: new Date(),
          initData: WebApp.initData,
        };

        if (userStatus === "new") {
          await axios.post(
            url,
            { ...payload, taskId: task._id },
            {
              headers: { "x-api-key": APIKey },
            }
          );
        } else if (userStatus === "reset") {
          await axios.put(`${url}/${task._id}/status`, payload, {
            headers: { "x-api-key": APIKey },
          });
        }

        setTasks((prevTasks) =>
          prevTasks.map((t) =>
            t._id === task._id ? { ...t, status: "verified" } : t
          )
        );

        toast.success("Message shared successfully!", {
          autoClose: 2000,
          position: "bottom-center",
          pauseOnFocusLoss: false, // Keep this here, it's a toast option
        });
        haptic.success();
      } catch (error) {
        console.error("Error updating task status:", error);
        toast.error("Something went wrong while saving progress.");
      } finally {
        setButtonLoading(false);
      }
    },
    [API_URL, userId, APIKey, WebApp, setTasks, toast, setButtonLoading, setMsg]
  );

  const onMessageFailed = useCallback(
    ({ error }) => {
      setMsg("shareMessageFailed event triggered with error:", error);
      // No need to call cleanupShareListeners here, it will be handled by the specific listener
      toast.error("Failed to share message. Please try again.", {
        autoClose: 2000,
        position: "bottom-center",
        pauseOnFocusLoss: false,
      });
      setButtonLoading(false);
    },
    [setMsg, toast, setButtonLoading]
  );

  const handleShare = useCallback(
    async (task, userStatus, mediaURL, caption) => {
      haptic.tap();
      const uniqueId = `photo_${Date.now()}_${Math.random()
        .toString(36)
        .substring(2, 8)}`;
      setButtonLoading(true);
      try {
        // Step 1: Save a prepared inline message via server proxy
        const response = await axios.post(
          `${API_URL}/api/tasks/share`,
          {
            userId: userId,
            result: {
              type: "photo",
              id: uniqueId,
              photo_url: mediaURL,
              thumb_url: mediaURL,
              title: "မြန်မာရုံတင်ကားကြီးများ အခမဲ့ ကြည့်နိုင်ပါပြီ။",
              description: "You can watch free movies on Biscope Myanmar App!",
              caption: caption,
              reply_markup: {
                inline_keyboard: [
                  [
                    {
                      text: "Watch Free Movies",
                      url: `https://t.me/biscopemyanmar_bot/store?startapp=${userData.referralCode}`,
                    },
                  ],
                  [
                    {
                      text: "Join App Channel",
                      url: "https://t.me/biscopemyanmarapp",
                    },
                  ],
                ],
              },
            },
          },
          {
            params: { initData: WebApp.initData },
            headers: { "x-api-key": APIKey },
          }
        );

        const msg_id = response.data.result.id;
        WebApp.onEvent("shareMessageSent", () =>
          onMessageSent(task, userStatus)
        );
        WebApp.onEvent("shareMessageFailed", onMessageFailed);
        // Step 2: Use the msg_id to call the shareMessage method
        WebApp.shareMessage(msg_id, function (success) {
          if (!success) {
            console.warn("User closed the dialog or an error occurred.");
          }
        });

        setButtonLoading(false);
      } catch (error) {
        console.error("Error sharing message:", error);
        toast.error("Error sharing message. Please try again.");
        setButtonLoading(false);
      }
    },
    [API_URL, userId, APIKey, WebApp, userData, onMessageSent, onMessageFailed, setButtonLoading, toast]
  );

  const handleShareStory = useCallback(async (task, userStatus) => {
    haptic.tap();
    // GA event for share story task
    ReactGA.event({
      category: "Task",
      action: "Share Story",
      label: task.name,
    });

    setButtonLoading(true);
    WebApp.shareToStory(task.URL, {
      text: task.caption,
      widget_link: {
        url: task.URL2,
        name: "Watch Movies",
      },
    });
    try {
      const url = `${API_URL}/api/user/${userId}/tasks`;
      if (userStatus === "new") {
        await axios.post(
          url,
          {
            taskId: task._id,
            status: "verified",
            initData: WebApp.initData,
          },
          {
            headers: {
              "x-api-key": APIKey,
            },
          }
        );
      }
      await new Promise((resolve) => setTimeout(resolve, 8000));

      setButtonLoading(false);
      setTasks((prevTasks) =>
        prevTasks.map((t) =>
          t._id === task._id ? { ...t, status: "verified" } : t
        )
      );
    } catch (error) {
      console.error("Error recording link click:", error);
    }
  }, [API_URL, userId, APIKey, WebApp, setTasks, setButtonLoading]);

  const handleExternalCode = useCallback(async (task, userStatus) => {
    // GA event for external code task
    ReactGA.event({
      category: "Task",
      action: "External Code",
      label: task.name,
    });

    // Open link immediately for better UX
    if (task.URL && (task.URL.includes("t.me") || task.URL.includes("telegram.me"))) {
      safeOpenTelegramLink(task.URL);
    } else {
      WebApp.openLink(task.URL, "_blank");
    }
    setButtonLoading(true);

    try {
      const url = `${API_URL}/api/user/${userId}/tasks`;
      if (userStatus !== "code") {
        await axios.post(
          url,
          {
            taskId: task._id,
            status: "code", // Set to 'code' so user can enter it
            initData: WebApp.initData,
          },
          {
            headers: { "x-api-key": APIKey },
          }
        );
      }

      setTasks((prevTasks) =>
        prevTasks.map((t) =>
          t._id === task._id ? { ...t, status: "code" } : t
        )
      );

      toast.info(`Complete the action on the site, then enter the code here.`, {
        position: "bottom-center",
        autoClose: 4000,
      });
      haptic.success();
    } catch (error) {
      console.error("Error recording external code task:", error);
      toast.error("Could not start task. Please try again.");
    } finally {
      setButtonLoading(false);
    }
  }, [API_URL, userId, APIKey, WebApp, setTasks, setButtonLoading, toast]);

  // const handleExternalCodeVerify = async (task) => {
  //   // GA event for external code verification
  //   ReactGA.event({
  //     category: "Task",
  //     action: "External Code Verify",
  //     label: task.name,
  //   });

  //   setButtonLoading(true);
  //   setModalOpen(true);
  //   setButtonLoading(false);
  // };

  const handleSubmit = useCallback((data, task) => {
    if (task.isManus) {
      if (!data.proof || !data.proof.includes('@')) {
        toast.error("Please enter a valid email.", { position: "bottom-center" });
        return;
      }
      setModalOpen(false);
      const url = `${API_URL}/api/user/${userId}/tasks/${task.taskId}/status`;
      axios.put(url, {
        status: "pending",
        proof: data.proof,
        initData: WebApp.initData,
      }, { headers: { "x-api-key": APIKey } });
      
      setTasks((prevTasks) =>
        prevTasks.map((t) =>
          t._id === task.taskId ? { ...t, status: "pending" } : t
        )
      );
      toast.success("Submitted for verification!", { position: "bottom-center" });
      haptic.success();
      return;
    }

    if (taskVerify.bscode === data.code) {
      setModalOpen(false);
      toast.success("Code verified successfully!", {
        autoClose: 2000,
        position: "bottom-center",
        pauseOnFocusLoss: false,
      });
      haptic.success();

      const url = `${API_URL}/api/user/${userId}/tasks/${task.taskId}/status`;

      axios.put(
        url,
        {
          status: "coded",
          initData: WebApp.initData,
        },
        {
          headers: {
            "x-api-key": APIKey,
          },
        }
      );

      setTasks((prevTasks) =>
        prevTasks.map((t) =>
          t._id === task.taskId ? { ...t, status: "coded" } : t
        )
      );

      // Trigger confetti effect
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
      });
    } else {
      toast.error("Invalid code. Please try again.", {
        autoClose: 2000,
        position: "bottom-center",
        pauseOnFocusLoss: false,
      });
    }
  }, [API_URL, userId, APIKey, WebApp, taskVerify, setModalOpen, setTasks, toast]);

  const handleManusReferral = useCallback(async (task, userStatus) => {
    ReactGA.event({ category: "Task", action: "Manus Referral", label: task.name });
    setButtonLoading(true);
    WebApp.openLink(task.URL, { try_instant_view: false });

    try {
      const url = `${API_URL}/api/user/${userId}/tasks`;
      if (userStatus === "new") {
        await axios.post(url, {
          taskId: task._id,
          status: "code", // Set to code so it shows "Enter Email"
          initData: WebApp.initData,
        }, { headers: { "x-api-key": APIKey } });
      } else if (userStatus === "unverified" || userStatus === "reset") {
        await axios.put(`${url}/${task._id}/status`, {
          status: "code",
          initData: WebApp.initData,
        }, { headers: { "x-api-key": APIKey } });
      }

      setTasks((prevTasks) =>
        prevTasks.map((t) =>
          t._id === task._id ? { ...t, status: "code", hasJoined: true } : t
        )
      );

      toast.info(`Enter your registered email after completing sign up.`, {
        position: "bottom-center",
        autoClose: 4000,
      });
      haptic.success();
    } catch (error) {
      console.error("Error recording manus referral task:", error);
    } finally {
      setButtonLoading(false);
    }
  }, [API_URL, userId, APIKey, WebApp, setTasks, setButtonLoading, toast]);

  const handleLinkClick = useCallback(async (task, userStatus) => {
    // GA event for link click
    ReactGA.event({
      category: "Task",
      action: "Link Click",
      label: task.name,
    });

    setButtonLoading(true);
    if (task.URL && (task.URL.includes("t.me") || task.URL.includes("telegram.me"))) {
      safeOpenTelegramLink(task.URL);
    } else {
      WebApp.openLink(task.URL, "_blank");
    }
    try {
      const url = `${API_URL}/api/user/${userId}/tasks`;

      // Choose POST or PUT based on user status
      if (userStatus === "new") {
        // If status is new, perform a POST request
        await axios.post(
          url,
          {
            taskId: task._id,
            status: "pending",
            initData: WebApp.initData,
          },
          {
            headers: {
              "x-api-key": APIKey,
            },
          }
        );
      } else if (userStatus === "unverified" || userStatus === "reset") {
        // If status is unverified, perform a PUT request
        await axios.put(
          `${API_URL}/api/user/${userId}/tasks/${task._id}/status`,
          {
            status: "pending",
            initData: WebApp.initData,
          },
          {
            headers: {
              "x-api-key": APIKey,
            },
          }
        );
      } else {
        toast.error("Invalid user status.");
        setButtonLoading(false);
        return; // Exit the function if the status is not valid
      }

      await new Promise((resolve) => setTimeout(resolve, 5000));
      setButtonLoading(false);
      // Handle the successful response
      toast.success(`Wait for the click to be verified!`, {
        autoClose: 1000,
        position: "bottom-center",
        pauseOnFocusLoss: false,
      });

      // Update local state
      setTasks((prevTasks) =>
        prevTasks.map((t) =>
          t._id === task._id ? { ...t, status: "pending", hasJoined: true } : t
        )
      );
    } catch (error) {
      console.error("Error recording link click:", error);
    }
  }, [API_URL, userId, APIKey, WebApp, setTasks, setButtonLoading, toast]);

  const handleBoost = useCallback(async (task, userStatus) => {
    // GA event for boost task
    ReactGA.event({
      category: "Task",
      action: "Boost",
      label: task.name,

      // Optional event fields
      value: task.points,
    });

    setButtonLoading(true);
    safeOpenTelegramLink(task.URL);
    setTasks((prevTasks) =>
      prevTasks.map((t) => (t._id === task._id ? { ...t, hasJoined: true } : t))
    );
    setButtonLoading(false);
  }, [WebApp, setTasks, setButtonLoading]);

  const handleBoostVerify = useCallback(async (task) => {
    haptic.tap();
    // GA event for boost verification
    ReactGA.event({
      category: "Task",
      action: "Boost Verify",
      label: task.name,
    });

    setButtonLoading(true);
    try {
      // Single atomic call: Telegram boost check + status update + point award + ledger write
      const response = await axios.post(
        `${API_URL}/api/tasks/verify-boost`,
        { taskId: task._id, initData: WebApp.initData },
        { headers: { "x-api-key": APIKey } }
      );

      if (response.data.verified) {
        setTasks((prevTasks) =>
          prevTasks.map((t) =>
            t._id === task._id ? { ...t, status: "completed" } : t
          )
        );
        setUserData((prev) => ({
          ...prev,
          user: {
            ...prev.user,
            points: response.data.points,
            tickets: response.data.tickets,
          },
        }));
        toast.success(`Boost verified! +${response.data.earnedPoints} Gems 🎉`, {
          autoClose: 2500,
          position: "bottom-center",
          pauseOnFocusLoss: false,
        });
        haptic.success();
        confetti({ particleCount: 100, spread: 70, origin: { y: 0.6 } });
      }
    } catch (error) {
      const msg = error.response?.data?.error || "Boost verification failed.";
      if (error.response?.status === 403) {
        toast.error("You need to boost the channel to earn points.", {
          autoClose: 2000,
          position: "bottom-center",
          pauseOnFocusLoss: false,
        });
      } else if (error.response?.status === 409) {
        toast.info("Boost already claimed.", { position: "bottom-center" });
      } else {
        toast.error(msg, { position: "bottom-center" });
      }
      console.error("Error verifying boost:", error);
    } finally {
      setButtonLoading(false);
    }
  }, [API_URL, APIKey, WebApp, setTasks, setUserData, setButtonLoading, toast]);

  // --- TON Wallet Connect task handlers ---

  // Called when user clicks "Connect" on the tonWalletConnect task.
  // If wallet is already connected → skip modal and verify immediately.
  // Otherwise → open modal; once connected, tonConnectUI auto-saves the
  // wallet via UserContext, then the user clicks "Verify" themselves.
  const handleTonWalletConnect = useCallback(async (task) => {
    haptic.tap();
    ReactGA.event({ category: "Task", action: "TON Wallet Connect", label: task.name });

    if (tonConnectUI.connected) {
      // Already connected — go straight to verification
      setButtonLoading(true);
      try {
        const response = await axios.post(
          `${API_URL}/api/tasks/verify-ton-wallet`,
          { taskId: task._id, initData: WebApp.initData },
          { headers: { "x-api-key": APIKey } }
        );
        if (response.data.verified) {
          setUserData((prev) => ({
            ...prev,
            user: { ...prev.user, points: response.data.points, tickets: response.data.tickets },
          }));
          setTasks((prev) => prev.map((t) => t._id === task._id ? { ...t, status: "completed" } : t));
          toast.success(`${response.data.earnedPoints} Gems + ${response.data.earnedTickets} Tickets claimed! 🎉`, {
            autoClose: 3000, position: "bottom-center", pauseOnFocusLoss: false,
          });
          haptic.success();
          confetti({ particleCount: 120, spread: 80, origin: { y: 0.6 } });
        } else {
          // wallet not linked on server yet — move to pending_ton so "Verify" appears
          setTasks((prev) => prev.map((t) => t._id === task._id ? { ...t, status: "pending_ton" } : t));
          toast.info("Wallet detected! Click Verify to claim your reward.", { position: "bottom-center" });
        }
      } catch (err) {
        console.error("[TON WALLET CONNECT] verify error:", err);
        toast.error("Verification failed. Please try again.", { position: "bottom-center" });
      } finally {
        setButtonLoading(false);
      }
      return;
    }

    // Wallet not connected — open modal and move task to pending_ton
    tonConnectUI.openModal();
    setTasks((prev) => prev.map((t) => t._id === task._id ? { ...t, status: "pending_ton" } : t));
    toast.info("Connect your wallet, then tap Verify to claim your reward.", {
      position: "bottom-center", autoClose: 5000,
    });
  }, [tonConnectUI, API_URL, APIKey, WebApp, userId, setTasks, setUserData, setButtonLoading, toast]);

  // Called when user clicks "Verify" after connecting their wallet.
  const handleTonWalletVerify = useCallback(async (task) => {
    haptic.tap();
    setButtonLoading(true);
    try {
      const response = await axios.post(
        `${API_URL}/api/tasks/verify-ton-wallet`,
        { taskId: task._id, initData: WebApp.initData },
        { headers: { "x-api-key": APIKey } }
      );
      if (response.data.verified) {
        setUserData((prev) => ({
          ...prev,
          user: { ...prev.user, points: response.data.points, tickets: response.data.tickets },
        }));
        setTasks((prev) => prev.map((t) => t._id === task._id ? { ...t, status: "completed" } : t));
        toast.success(`${response.data.earnedPoints} Gems + ${response.data.earnedTickets} Tickets claimed! 🎉`, {
          autoClose: 3000, position: "bottom-center", pauseOnFocusLoss: false,
        });
        haptic.success();
        confetti({ particleCount: 120, spread: 80, origin: { y: 0.6 } });
      } else {
        // Wallet not yet linked on server — open modal again
        tonConnectUI.openModal();
        toast.warning("Wallet not connected yet. Please connect and try again.", {
          position: "bottom-center", autoClose: 4000,
        });
      }
    } catch (err) {
      console.error("[TON WALLET VERIFY] error:", err);
      toast.error("Verification failed. Please try again.", { position: "bottom-center" });
    } finally {
      setButtonLoading(false);
    }
  }, [tonConnectUI, API_URL, APIKey, WebApp, setTasks, setUserData, setButtonLoading, toast]);

  // ------------------------------------------

  // --- TelePay Visit task handler ---
  const handleTelepayVisit = useCallback(async (task) => {
    haptic.tap();
    // Step 1: Open TelePay (visit is recorded silently inside TelePay on load)
    safeOpenTelegramLink(task.URL);
    // Optimistically mark hasJoined so button flips to "Verify"
    setTasks((prev) =>
      prev.map((t) => (t._id === task._id ? { ...t, hasJoined: true } : t))
    );
  }, [WebApp, setTasks]);

  const handleTelepayVisitVerify = useCallback(async (task) => {
    haptic.tap();
    setButtonLoading(true);
    try {
      const response = await axios.post(
        `${API_URL}/api/tasks/verify-telepay-visit`,
        { taskId: task._id, initData: WebApp.initData },
        { headers: { "x-api-key": APIKey } }
      );
      if (response.data.verified) {
        setUserData((prev) => ({
          ...prev,
          user: { ...prev.user, points: response.data.points, tickets: response.data.tickets },
        }));
        setTasks((prev) =>
          prev.map((t) => (t._id === task._id ? { ...t, status: "completed" } : t))
        );
        toast.success(`${response.data.earnedPoints} Gems claimed! 🎉`, {
          autoClose: 3000, position: "bottom-center", pauseOnFocusLoss: false,
        });
        haptic.success();
        confetti({ particleCount: 100, spread: 70, origin: { y: 0.6 } });
      }
    } catch (err) {
      const msg = err.response?.data?.error || "Verification failed. Make sure you opened TelePay first.";
      toast.error(msg, { position: "bottom-center", autoClose: 3000 });
      setTasks((prev) =>
        prev.map((t) => (t._id === task._id ? { ...t, status: "unverified" } : t))
      );
    } finally {
      setButtonLoading(false);
    }
  }, [API_URL, APIKey, WebApp, setTasks, setUserData, setButtonLoading, toast]);

  // --- TelePay Top Up task handler ---
  const handleTelepayTopup = useCallback(async (task) => {
    haptic.tap();
    // Open TelePay so the user can do a top-up
    safeOpenTelegramLink(task.URL);
    setTasks((prev) =>
      prev.map((t) => (t._id === task._id ? { ...t, hasJoined: true } : t))
    );
  }, [WebApp, setTasks]);

  const handleTelepayTopupVerify = useCallback(async (task) => {
    haptic.tap();
    setButtonLoading(true);
    try {
      const response = await axios.post(
        `${API_URL}/api/tasks/verify-telepay-topup`,
        { taskId: task._id, initData: WebApp.initData },
        { headers: { "x-api-key": APIKey } }
      );
      if (response.data.verified) {
        setUserData((prev) => ({
          ...prev,
          user: { ...prev.user, points: response.data.points, tickets: response.data.tickets },
        }));
        setTasks((prev) =>
          prev.map((t) => (t._id === task._id ? { ...t, status: "completed" } : t))
        );
        toast.success(`${response.data.earnedPoints} Gems claimed! 🎉`, {
          autoClose: 3000, position: "bottom-center", pauseOnFocusLoss: false,
        });
        haptic.success();
        confetti({ particleCount: 100, spread: 70, origin: { y: 0.6 } });
      }
    } catch (err) {
      const msg = err.response?.data?.error || "No completed top-up found. Top up at least 3,000 MMK in TelePay first.";
      toast.error(msg, { position: "bottom-center", autoClose: 4000 });
      setTasks((prev) =>
        prev.map((t) => (t._id === task._id ? { ...t, status: "unverified" } : t))
      );
    } finally {
      setButtonLoading(false);
    }
  }, [API_URL, APIKey, WebApp, setTasks, setUserData, setButtonLoading, toast]);

  // ------------------------------------------

  // --- TON Daily Check-In handler ---
  const handleTonCheckIn = useCallback(async (task) => {
    haptic.tap();
    ReactGA.event({ category: "Task", action: "TON Check-In", label: task.name });

    if (!tonConnectUI.connected) {
      tonConnectUI.openModal();
      toast.info("Connect your TON wallet first, then come back to check in.", {
        position: "bottom-center", autoClose: 5000,
      });
      return;
    }

    setButtonLoading(true);
    try {
      const result = await buyWithTon({ taskId: task._id }, userId, APIKey, tonConnectUI);
      if (result.state !== "fulfilled") {
        toast.info(`Check-in payment pending. Resume in Profile → Purchases. Order: ${result.orderId}. Do not pay again.`);
        return;
      }
      if (result.state === "fulfilled") {
        await refreshUser();
        setTasks((prev) => prev.map((t) => t._id === task._id ? { ...t, status: "completed" } : t));
        toast.success(`Check-in completed! Your rewards have been credited. 💎`, {
          autoClose: 3000, position: "bottom-center", pauseOnFocusLoss: false,
        });
        haptic.success();
        confetti({ particleCount: 120, spread: 80, origin: { y: 0.6 } });
      }
    } catch (err) {
      console.error("[TON CHECKIN] error:", err);
      if (err?.message?.includes("Reject")) {
        toast.error("Transaction rejected.", { position: "bottom-center" });
      } else if (err?.response?.data?.error) {
        toast.error(err.response.data.error, { position: "bottom-center", autoClose: 4000 });
      } else {
        toast.error("Check-in failed. Please try again.", { position: "bottom-center" });
      }
      haptic.error();
    } finally {
      setButtonLoading(false);
    }
  }, [tonConnectUI, userId, APIKey, refreshUser]);
  // -------------------------------------------

  const handleClaim = useCallback(async (task) => {
    // GA event for task claim
    ReactGA.event({
      category: "Task",
      action: "Claim",
      label: task.name,
    });
    setButtonLoading(true);

    // Optimistic UI Update — snapshot current state for rollback
    const originalTasks = tasks;
    const originalUserData = { ...userData };

    setTasks((prevTasks) =>
      prevTasks.map((t) =>
        t._id === task._id ? { ...t, status: "completed" } : t
      )
    );
    setUserData((prev) => ({
      ...prev,
      user: {
        ...prev.user,
        points: (prev.user?.points || 0) + task.points,
        tickets: (prev.user?.tickets || 0) + task.tickets,
      },
    }));
    toast.success(`${task.points} points claimed!`, { position: "bottom-center" });
    haptic.success();

    showAd();

    try {
      // Single atomic call: status update + point award + ledger write
      const response = await axios.post(
        `${API_URL}/api/user/${userId}/tasks/${task._id}/claim`,
        { initData: WebApp.initData },
        { headers: { "x-api-key": APIKey } }
      );

      // Sync UI with server-confirmed values
      setUserData((prev) => ({
        ...prev,
        user: {
          ...prev.user,
          points: response.data.points,
          tickets: response.data.tickets,
        },
      }));

      // Trigger confetti effect
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
      });
    } catch (error) {
      console.error("Error claiming task:", error);
      toast.error("Claim failed. Reverting changes.");
      // Revert UI on error
      setTasks(originalTasks);
      setUserData(originalUserData);
    } finally {
      setButtonLoading(false);
    }
  }, [tasks, userData, userId, API_URL, APIKey, WebApp, setTasks, setUserData, setButtonLoading, toast]);

  // Define handlers object to pass to TaskCard
  const taskHandlers = useMemo(
    () => ({
      handleJoin,
      handleVerify,
      handleShare,
      handleShareStory,
      handleLinkClick,
      handleExternal,
      handleExternalCode,
      setModalOpen,
      setTaskVerify,
      handleBoost,
      handleBoostVerify,
      handleClaim,
      handleTonWalletConnect,
      handleTonWalletVerify,
      handleTonCheckIn,
      handleTelepayVisit,
      handleTelepayVisitVerify,
      handleTelepayTopup,
      handleTelepayTopupVerify,
      handleManusReferral,
    }),
    [
      handleJoin,
      handleVerify,
      handleShare,
      handleShareStory,
      handleLinkClick,
      handleExternal,
      handleExternalCode,
      handleBoost,
      handleBoostVerify,
      handleClaim,
      handleTonWalletConnect,
      handleTonWalletVerify,
      handleTonCheckIn,
      handleTelepayVisit,
      handleTelepayVisitVerify,
      handleTelepayTopup,
      handleTelepayTopupVerify,
      handleManusReferral,
    ]
  );

  if (loading) {
    return <TaskSkeleton />;
  }

  const sectionConfig = {
    "New Tasks":       { emoji: "📋", color: "text-slate-700 dark:text-slate-200", emptyIcon: "tasks",   emptyTitle: "No active tasks",   emptySub: "Check back later for new tasks!" },
    "Pending Tasks":   { emoji: "⏳", color: "text-amber-600 dark:text-amber-400", emptyIcon: "tasks",   emptyTitle: "No pending tasks",  emptySub: "Your submitted tasks will appear here." },
    "Daily Tasks":     { emoji: "🌅", color: "text-sky-600 dark:text-sky-400",    emptyIcon: "tasks",   emptyTitle: "No daily tasks yet", emptySub: "Daily tasks refresh every 24 hours." },
    "Completed Tasks": { emoji: "✅", color: "text-[#0C8BC4]", emptyIcon: "history", emptyTitle: "No completed tasks", emptySub: "Completed tasks will show here." },
  };

  const taskList = (tasks, title, statusClass, wrapperClass) => {
    const cfg = sectionConfig[title] || { emoji: "📌", color: "text-fuchsia-500 dark:text-fuchsia-400", emptyIcon: "tasks", emptyTitle: "No tasks", emptySub: "" };
    return (
    <motion.section
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className={`${wrapperClass} my-4`}
    >
      {/* Section heading */}
      <div className="flex items-center gap-2 mb-3">
        <span className="text-lg">{cfg.emoji}</span>
        <h2 className={`text-base font-bold ${cfg.color}`}>{title}</h2>
        <span className="ml-auto bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 text-xs font-semibold px-2 py-0.5 rounded-full">
          {tasks.length}
        </span>
      </div>

      <div className="overflow-hidden">
        <AnimatePresence>
          {title === "Daily Tasks" && (
            <>
              <ShowAdButton
                userId={userId}
                webApp={WebApp.initData}
                APIKey={APIKey}
                onPointsUpdate={(newPoints) =>
                  setUserData((prev) => ({
                    ...prev,
                    user: {
                      ...prev.user,
                      points: prev.user.points + newPoints,
                      tickets: prev.user.tickets,
                    },
                  }))
                }
              />
            </>
          )}
          {tasks.length > 0 ? (
            tasks.map((task) => (
              <TaskCard
                key={task._id}
                task={task}
                buttonLoading={buttonLoading}
                handlers={taskHandlers}
              />
            ))
          ) : (
            <EmptyState icon={cfg.emptyIcon} title={cfg.emptyTitle} subtitle={cfg.emptySub} />
          )}
        </AnimatePresence>
      </div>
    </motion.section>
  );};


  const dailyTasks = tasks.filter((task) => task.isDaily === true);
  const newTasks = tasks.filter(
    (task) =>
      task.isDaily !== true &&
      (task.status === "new" ||
        task.status === "unverified" ||
        task.status === "boosted" ||
        task.status === "code" ||
        task.status === "coded" ||
        task.status === "pending_ton")
  );
  const pendingTasks = tasks.filter(
    (task) => task.status === "pending" || task.status === "verified"
  );
  const completedTasks = tasks.filter(
    (task) => task.status === "completed" || task.status === "banned"
  );

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
      className="bg-slate-50 dark:bg-slate-800 text-slate-900 dark:text-white min-h-screen pb-24 transition-colors duration-300"
    >
      <Suspense fallback={null}>
        <Joyride
          steps={taskSteps}
          run={run}
          callback={handleCallback}
          tooltipComponent={CustomTooltip}
          showSkipButton
          showProgress
          continuous
          scrollToFirstStep
          scrollOffset={50}
          disableOverlayClose
          spotlightClicks={false}
          styles={{
            options: { zIndex: 10000, arrowColor: "#475569" },
            spotlight: {
              borderRadius: "12px",
              boxShadow: "0 0 0 4px rgba(59, 130, 246, 0.6)",
            },
          }}
        />
      </Suspense>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="container mx-auto py-20 px-4 flex flex-col"
      >
          <button
            onClick={restart}
            className="restartTour fixed bottom-20 right-6 z-50 text-fuchsia-600 transition-all flex items-center"
            title="Restart Tour"
          >
            <FaPlayCircle className="inline-block mr-1 text-2xl" />
          </button>
          {msg && (
            <div className="bg-[#0C8BC4] text-white p-2 rounded-md mb-4 text-center">
              {msg}
            </div>
          )}


          <Suspense fallback={<Loading />}>
            <FormModal
              isOpen={isModalOpen}
              onClose={() => setModalOpen(false)}
              onSubmit={(data) => handleSubmit(data, taskVerify)}
              taskVerify={taskVerify}
            />
          </Suspense>
          <div className="flex justify-center mb-2">
            <div className="w-full max-w-md">
              <Tabs
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                tabs={[
                  { id: "active", label: "Active", icon: <FaListAlt /> },
                  { id: "daily", label: "Daily", icon: <FaCalendar /> },
                  { id: "completed", label: "History", icon: <FaHistory /> },
                ]}
              />
            </div>
          </div>
          {activeTab === "daily" && (
            <>{taskList(dailyTasks, "Daily Tasks", "bg-sky-800", "")}</>
          )}
          {activeTab === "active" && (
            <>
              {taskList(newTasks, "New Tasks", "")}
              {taskList(
                pendingTasks,
                "Pending Tasks",
                "bg-amber-600",
                "pendingTasks"
              )}
              <AdSense.Google
                client="ca-pub-4252052358641832"
                slot="4385377268"
                style={{ display: "block" }}
                format="auto"
                responsive="true"
                layoutKey="-gw-1+2a-9x+5c"
              />
            </>
          )}
          {activeTab === "completed" && (
            <>
              {taskList(completedTasks, "Completed Tasks", "bg-gray-600")}
              <AdSense.Google
                client="ca-pub-4252052358641832"
                slot="4385377268"
                style={{ display: "block" }}
                format="auto"
                responsive="true"
                layoutKey="-gw-1+2a-9x+5c"
              />
            </>
          )}
        </motion.div>
        {/* End of layout */}
    </motion.div>
  );
};

export default Tasks;
